import { SelectionBar, DownloadButton } from '@anytag/shared-atoms';
import { DropdownOption } from '@anytag/shared-types';
import { ReportGroupBy } from './hooks';

interface ActionBarProps {
  loading: boolean;
  allItemIds: string[];
  selectedIds: string[];
  hasAllItemsSelected: boolean;
  toggleSelectAllItems: () => void;
  handleDownloadReport: (o: ReportGroupBy) => void;
  downloadOptions: DropdownOption[];
}
export const ActionBar = ({
  loading,
  allItemIds,
  selectedIds,
  downloadOptions,
  hasAllItemsSelected,
  toggleSelectAllItems,
  handleDownloadReport
}: ActionBarProps) =>
  selectedIds.length ? (
    <SelectionBar
      disabled={loading}
      selectAllProps={{ onClick: toggleSelectAllItems, label: false }}
      checkboxProps={
        allItemIds.length
          ? {
              disabled: loading,
              onClick: toggleSelectAllItems,
              indeterminate: !hasAllItemsSelected,
              label: false
            }
          : undefined
      }
    >
      <DownloadButton
        variant="solid"
        options={downloadOptions}
        onSelectOption={(o) => handleDownloadReport(o.value as ReportGroupBy)}
        className="ml-4 min-w-max pr-4"
        loading={loading}
      />
    </SelectionBar>
  ) : null;
